import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';

import { useApiSDK } from '../../../contexts/apiSdkContext';
import { AppContext } from '../../../pages/layout';

type TDeviceDeleteExportHook = {
  isError: boolean;
  isLoading: boolean;
  mutate: UseMutationResult<void, unknown, string, unknown>['mutate'];
};

function useDeleteDeviceExport(): TDeviceDeleteExportHook {
  const sdk = useApiSDK();
  const appContext = useContext(AppContext);

  const queryClient = useQueryClient();

  const { isError, isLoading, mutate } = useMutation({
    mutationFn: (id: string) => {
      return sdk.devices.delete_export(id);
    },
    onSuccess: async (_contexts) => {
      await queryClient.invalidateQueries(['device-exports']);
      await queryClient.invalidateQueries(['device-export']);
      appContext?.crudAlert('delete', 'device export', 'm');
    },
    onError: async (error: any) => {
      if (error) {
        const responseErrors = error.response.data.errors;
        responseErrors.forEach((err: { message: string; description: string }) => {
          appContext?.systemAlert('error', err.description);
        });
      }
    },
  });

  return { isError, isLoading, mutate };
}

export { useDeleteDeviceExport };
